import { DraggableProvidedDragHandleProps } from '@hello-pangea/dnd';

export function dragHandleAttributes(className: string, dragHandleProps?: DraggableProvidedDragHandleProps | null) {
  if (!dragHandleProps) {
    return { className };
  }

  return {
    ...dragHandleProps,
    className: `${className} queryBuilder__drag-handle`,
    'data-testid': 'query-builder-drag-handle',
  };
}
